import React, {useEffect} from "react"
import classes from './styles.module.css'

import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"
import Spinner from 'common/Spinner'
import HelmetComponent from 'components/Helmet'

const CommonPage1: React.FC = () => {

  const { i18n } = useTranslation()
  const location = useLocation()


  // const { isLoading, isFetching, error, data, refetch } = useQuery( ['page'],
  //   async () => {
  //     const { data } = await axios("https://api.chucknorris.io/jokes/random");
  //     return data;
  //   }
  // );

  // console.log('common page')


  
  return (
    <>
      <HelmetComponent title='Πολιτική Απορρήτου' descrition="SEO Προσωπικά Δεδομένα και Πολιτική Απορρήτου περιγραφή" />
      
      <div className={classes.container}>
        <h3 className={classes.h3}>Πολιτική Απορρήτου</h3>
        <div>
        <b>Ποια προσωπικά μου δεδομένα συλλέγονται και πώς;</b>

<p>Τα προσωπικά δεδομένα τα οποία συλλέγει και επεξεργάζεται ο Δήμος Ρεθύμνης είναι μόνο αυτά που είναι απαραίτητα για τον εκάστοτε συγκεκριμένο και σαφώς ορισμένο σκοπό και τη συγκεκριμένη νομική βάση.

Στο πλαίσιο αυτό, η επεξεργασία που λαμβάνει χώρα αφορά τα προσωπικά δεδομένα που παρέχετε στην ο Δήμος Ρεθύμνης σε πραγματικό διαδραστικό χρόνο, όταν χρησιμοποιείτε τις υπηρεσίες μας, τους επίσημους διαδικτυακούς μας τόπους, για παράδειγμα κάνοντας εγγραφή, όπως:
<ul>
<li>Όνομα</li>
<li>Επώνυμο</li>
<li>E-mail</li>
</ul>
Σε όσες από τις περιπτώσεις η επεξεργασία θεμελιώνεται στη λήψη συγκατάθεσης, ο Δήμος Ρεθύμνης ακολουθεί τις προβλεπόμενες από το Νόμο διαδικασίες για τη λήψη αυτής.
</p>
<b>Για ποιους σκοπούς γίνεται η επεξεργασία και ποια η νομική της βάση;</b>
<p>
Τα προσωπικά δεδομένα συλλέγονται σύμφωνα με τον ΓΚΠΔ και την ισχύουσα νομοθεσία, είτε με την έναρξη της σχέσης σας με τον Οργανισμό είτε και μεταγενέστερα και αποτελούν αντικείμενο επεξεργασίας με νομική βάση:
</p><p>
Τη συγκατάθεσή σας, όταν απαιτείται
</p><p>
Την εκτέλεση μιας μεταξύ μας σύμβασης
</p><p>
Την εκπλήρωση των νομικών μας υποχρεώσεων
</p><p>
Τη διαφύλαξη ζωτικού συμφέροντος
</p><p>
Την εκπλήρωση καθήκοντος για το δημόσιο συμφέρον
</p><p>
Τη διαφύλαξη έννομου συμφέροντός μας ή τρίτου
</p>
<p>
ο Δήμος Ρεθύμνης μπορεί να επεξεργαστεί τα προσωπικά σας δεδομένα, για τους ακόλουθους σκοπούς ανά νομική βάση:
</p>
<ol>
<p><li>Με τη συγκατάθεσή σας</li>
Μεταβίβαση προσωπικών δεδομένων σε τρίτους<br/>

Αποστολή ενημερώσεων
</p>
<p>
<li>Για την εκπλήρωση της συμβατικής υποχρέωσης σε περίπτωση σύναψης σύμβασης με τον Δήμο Ρεθύμνης ή κατά την προσυμβατική διαδικασία</li>
<li>Για την επικοινωνία κατά την προσυμβατική διαδικασία ή κατά την εκτέλεση της σύμβασης</li>
</p>
<p>
<li>Για την εκπλήρωση των νομικών μας υποχρεώσεων</li>
Για την εκπλήρωση των υποχρεώσεών μας σύμφωνα με την ισχύουσα νομοθεσία έναντι δημοσίων αρχών και φορέων (Εποπτικές, Ανεξάρτητες, Αστυνομικές, Δικαστικές).
</p>
<p>
<li>Για τη διαφύλαξη ζωτικού συμφέροντος σας ή τρίτου</li>
Σε περίπτωση που κινδυνεύει η ζωή σας ή η ζωή τρίτου
</p>
<p>
<li>Για λόγους έννομου συμφέροντός μας, ως:</li>
Για την ανάπτυξη και βελτίωση των παρεχόμενων υπηρεσιών μας μέσα από τις δραστηριότητες και τα ενδιαφέροντά σας. Για τη διαχείριση των παραπόνων σας. Για την προστασία και ασφάλεια των συστημάτων πληροφορικής.
</p></ol>
<p>
<b>Ποιοι είναι οι αποδέκτες των προσωπικών μου δεδομένων;</b></p>
<p>
Πρόσβαση στα προσωπικά σας δεδομένα έχει το προσωπικό του Δήμου Ρεθύμνης, στα πλαίσια της εκτέλεσης των καθηκόντων που τους ανέθεσε ο Δήμος Ρεθύμνης ως υπεύθυνος επεξεργασίας. Ο Δήμος Ρεθύμνης είναι υποχρεωμένος ή δικαιούται να κοινοποιεί τα προσωπικά σας δεδομένα σε διάφορους τρίτους αποδέκτες όπως: Δημόσιους φορείς Ανεξάρτητες αρχές υπό τον όρο της τήρησης σε κάθε περίπτωση του απορρήτου και του καθήκοντος εμπιστευτικότητας και εχεμύθειας.
</p>
<b>Πόσο χρόνο διατηρούνται τα δεδομένα μου;</b>
<p>
O Δήμος Ρεθύμνης διατηρεί τα προσωπικά σας δεδομένα μόνον για το διάστημα που απαιτείται για τους σκοπούς της επεξεργασίας. Ωστόσο οφείλει να διατηρεί τα προσωπικά δεδομένα και για χρονικό διάστημα που καθορίζεται από το ισχύον νομικό και κανονιστικό πλαίσιο.
</p>

<b>Τι είναι τα cookies και γιατί τα συλλέγει ο Δήμος Ρεθύμνης;</b>
<p>
Για να διασφαλίσουμε ότι ο ιστότοπός μας λειτουργεί σωστά, ενδέχεται μερικές φορές να αποθηκευτεί ένα μικρό κομμάτι δεδομένων που είναι γνωστό ως cookie στον υπολογιστή ή την κινητή συσκευή σας κατά την επίσκεψη του ιστότοπού μας. Ένα cookie είναι ένα αρχείο κειμένου που αποθηκεύεται από έναν διακομιστή ιστού σε έναν υπολογιστή ή μια κινητή συσκευή. Το περιεχόμενο ενός cookie μπορεί να ανακτηθεί ή να διαβαστεί μόνο από το διακομιστή που δημιουργεί το cookie. Το κείμενο σε ένα cookie αποτελείται συχνά από αναγνωριστικά, ονόματα τοποθεσιών και ορισμένους αριθμούς και χαρακτήρες. Τα cookies είναι μοναδικά για τα προγράμματα περιήγησης ή τις κινητές εφαρμογές που χρησιμοποιείτε και επιτρέπουν στους ιστότοπους να αποθηκεύουν δεδομένα όπως οι προτιμήσεις σας.
</p>
<b>Πως προστατεύονται τα δεδομένα μου;</b>
<p>
Στον Δήμος Ρεθύμνης εργαζόμαστε καθημερινά για να εξασφαλίσουμε ότι τα προσωπικά δεδομένα που λαμβάνουμε: Υποβάλλονται σε σύννομη και θεμιτή επεξεργασία με διαφανή τρόπο σε σχέση με το υποκείμενο των δεδομένων. Συλλέγονται αποκλειστικά για συγκεκριμένους και νόμιμους σκοπούς. Είναι επαρκή, σχετίζονται με το σκοπό για τον οποίο τα συλλέγουμε και περιορίζονται στα απαραίτητα. Είναι ακριβή και ενημερωμένα. Διατηρούνται αποκλειστικά εντός του καθορισμένου χρονικού πλαισίου και όχι περισσότερο. Τίθενται σε επεξεργασία με τέτοιο τρόπο ώστε να εξασφαλίζεται η απαραίτητη προστασία τους.
</p>
<b>Ποια είναι τα δικαιώματά μου;</b>

<p>O Δήμος Ρεθύμνης δεν επεξεργάζεται με αυτοματοποιημένο τρόπο και δεν δημιουργεί προφίλ για κανένα φυσικό πρόσωπο του οποίου διατηρεί τα προσωπικά δεδομένα Το υποκείμενο των δεδομένων έχει τα ακόλουθα δικαιώματα:
</p>
<b>Το δικαίωμα πρόσβασης</b>
<p>
Μπορείτε ανά πάσα στιγμή να ενημερωθείτε από εμάς για τα προσωπικά σας δεδομένα που διατηρούμε, και να έχετε πρόσβαση σε αυτά.
</p>
<b>Το δικαίωμα στη διόρθωση δεδομένων</b>

<p>Έχετε τη δυνατότητα να απευθυνθείτε σε εμάς για να διορθώσουμε τα δεδομένα που είναι ανακριβή ή ελλιπή.</p>

<b>Το «δικαίωμα στη λήθη»</b>
<p>
Εφόσον δεν μας υποχρεώνει κάποιο νομοθετικό πλαίσιο να διατηρήσουμε τα δεδομένα που διατηρούμε και σχετίζονται με εσάς, μπορείτε να μας ζητήσετε να τα διαγράψουμε.
</p>
<b>Το δικαίωμα στη φορητότητα των δεδομένων</b>
<p>
Μπορείτε να μας ζητήσετε να διαβιβάσουμε τα δεδομένα σας σε άλλο δημόσιο ή ιδιωτικό φορέα.
</p>
<b>Το δικαίωμα στην εναντίωση και στον περιορισμό της επεξεργασίας</b>
<p>
Σε περίπτωση που διαφωνείτε με τον τρόπο που επεξεργαζόμαστε τα προσωπικά σας δεδομένα μπορείτε να αιτηθείτε τη διακοπή ή τον περιορισμό της επεξεργασίας.
</p>
<b>Το δικαίωμα άρσης συγκατάθεσης</b>
<p>
Έχετε το δικαίωμα να αποσύρετε τη συγκατάθεσή σας στην επεξεργασία των δεδομένων σας ανά πάσα στιγμή. Ο Δήμος Ρεθύμνης θα καταβάλει κάθε προσπάθεια να απαντήσει στο αίτημα που θα υποβάλλετε χωρίς καθυστέρηση και σε κάθε περίπτωση εντός μηνός από την παραλαβή του. Η εν λόγω προθεσμία παρατείνεται για δύο (2) ακόμα μήνες, εφόσον είναι απαραίτητο λαμβάνοντας υπόψη την πολυπλοκότητα του αιτήματος και το πλήθος των αιτημάτων. Η ΕΦΑ Δωδεκανήσου θα σας ενημερώσει για την εν λόγω παράταση εντός μηνός από την παραλαβή του αιτήματος, καθώς και για τους λόγους της καθυστέρησης. Εάν έχετε υποβάλει το αίτημα με ηλεκτρονικά μέσα, η ενημέρωση παρέχεται, εάν είναι δυνατόν, με ηλεκτρονικά μέσα, εκτός εάν εσείς ζητήσετε κάτι διαφορετικό. Εφόσον ο ΕΦΑΗ ικανοποιήσει αίτημά σας α) για περιορισμό επεξεργασίας των δεδομένων σας ή β) για άρνηση επεξεργασίας των δεδομένων σας ή γ) για διαγραφή των δεδομένων σας από τα αρχεία του οργανισμού και εφόσον αυτά είναι απαραίτητα για την κατάρτιση ή τη συνέχιση και εκτέλεση σύμβασης, τότε αυτό συνεπάγεται αυτοδίκαια είτε την καταγγελία από εσάς της αντίστοιχης σύμβασης ή τη μη δυνατότητα επεξεργασίας του σχετικού σας αιτήματος.
</p>
<b>Ανάκληση της συγκατάθεσης</b>
<p>
Έχετε το δικαίωμα να ανακαλέσετε τη συγκατάθεσή σας ανά πάσα στιγμή. Η ανάκληση της συγκατάθεσης σας δε θίγει τη νομιμότητα της επεξεργασίας που βασίστηκε σε αυτή και έγινε πριν της ανάκλησής της.
</p>
<b>Cookies</b>
<p>
Για να διασφαλίσουμε ότι ο ιστότοπός μας και η εφαρμογή για κινητές συσκευές λειτουργούν σωστά, ενδέχεται μερικές φορές να τοποθετήσουμε ένα μικρό κομμάτι δεδομένων που είναι γνωστό ως cookie στον υπολογιστή ή την κινητή συσκευή σας. Ένα cookie είναι ένα αρχείο κειμένου που αποθηκεύεται από έναν διακομιστή ιστού σε έναν υπολογιστή ή μια κινητή συσκευή. Το περιεχόμενο ενός cookie μπορεί να ανακτηθεί ή να διαβαστεί μόνο από το διακομιστή που δημιουργεί το cookie. Το κείμενο σε ένα cookie αποτελείται συχνά από αναγνωριστικά, ονόματα τοποθεσιών και ορισμένους αριθμούς και χαρακτήρες. Τα cookies είναι μοναδικά για τα προγράμματα περιήγησης ή τις κινητές εφαρμογές που χρησιμοποιείτε και επιτρέπουν στους ιστότοπους να αποθηκεύουν δεδομένα όπως οι προτιμήσεις σας.
</p>
<b>Υπεύθυνος Προστασίας Δεδομένων</b>
<p>
Σε περίπτωση που έχετε ερωτήσεις σχετικά με την προστασία των δεδομένων σας και τα δικαιώματά σας, μπορείτε να στείλετε email ή να απευθυνθείτε εγγράφως και θα απαντήσουμε σε αυτές το συντομότερο δυνατόν και όχι αργότερα από ένα μήνα.
</p>
        </div>
      </div> 
    </>
  )
}

export default CommonPage1
